import React, { Fragment, useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { ThemeContext } from "styled-components";
import FeatureContainer from "../../../../Layout/Containers/FeatureContainer";
import { CreateButton } from "../../../../CommonElements";
import { FEATURE_FUNCTION_SELECTION } from "../../../../Constant/FeatureSelection";
import FilterComponent from "../../../FilterComponents/FilterComponent";
import useAxios from "../../../../Utils/useAxios";
import { filterSearch } from "../../../../Utils/FilterItems";
import DaftarCapaianSSColumns from "../constants/getCapaianSSColumns";
import getCapaianSS from "../services/getCapaianSS";


const CapaianSSContain = () => {
  const axiosInstance = useAxios();
  const [capaianSSList, setCapaianSSList] = useState([]);
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [pending, setPending] = useState(true);    

  useEffect(() => {
    capaianSS();
  }, [])
  
  const capaianSS = async () => {
    getCapaianSS(axiosInstance).then((res) => {
      setCapaianSSList(res.data);
      setPending(false);
    })
  }

  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  }

  const filterCapaian = (items) => {
    const searchCategories = [
      "entitas",
      "perspektif",
      "kode_ss",
      "nama_ss",
      "bobot_ss"
    ];
    const filteredItems = items.filter(
      filterSearch(searchCategories, filterText)
    )

    return filteredItems;
  }

  return(
    <FeatureContainer
      title={"CapaianSS"}
      statusList={filterCapaian(capaianSSList)}
      createButton={
        FEATURE_FUNCTION_SELECTION.CapaianSS.Create && (
          <CreateButton
            url={`${process.env.PUBLIC_URL}/capaianss/formcapaianss`}
          >
            Buat Capaian SS
          </CreateButton>
        )
      }
    >
      <DataTable
        columns={DaftarCapaianSSColumns(capaianSS, axiosInstance, filterText)}
        data={filterCapaian(capaianSSList)}
        pagination
        selectableRowsHighlight
        subHeader
        subHeaderComponent={
          <FilterComponent
            onFilter={(e) => {
              setFilterText(e.target.value);
            }}
            onClear={() => handleClear()}
            filterText={filterText}
          />
        }
        subHeaderAlign="right"
        persistTableHead
        progressPending={pending}
        theme={ThemeContext}
      />
        
    </FeatureContainer>
  )

}

export default CapaianSSContain;